import React from 'react';
import { colors } from '../../colors';
import { Link } from 'react-router-dom';

const NoSubscriptionsNotice = () => {
  return (
    <div
      className="overview-content-loading-container"
      style={{
        color: colors.white,
        flexDirection: 'column',
        fontWeight: 'bold',
        fontSize: 20,
      }}
    >
      <p style={{ margin: 0 }}>No subscriptions found yet</p>
      <p style={{ margin: 0 }}>
        Please go to the{' '}
        <span>
          <Link to={'/discover'} style={{ color: 'yellowgreen' }}>
            Discover page
          </Link>
        </span>{' '}
        to subscribe to your first bot
      </p>
    </div>
  );
};

export default NoSubscriptionsNotice;
